/**
 * 
 * key
 * 
 */


const key = 'cHJlQ2hhbmdlc0luUHJvZ3Jlc3M='

export default key 